export default {
  text: {
    en: 'Changes successfully saved',
  },
}
